// extracted by mini-css-extract-plugin
module.exports = {"icon":"User_icon__1dytk","checkmark-false":"User_checkmark-false__1Ba87","checkmark-true":"User_checkmark-true__3JSvK","confirmed":"User_confirmed__pLCcV"};